import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { IoIosArrowBack, IoIosInformationCircleOutline } from "react-icons/io"
import { AbsoluteContainer, AppSpan, AppText, Button, CustomContainer, FlexRow, GridContainer } from "src/style"
import utility from "src/utils/utility"
import helpers from "src/utils/helpers"
import { Approve_DeclineUpgradeRequest, DocumentPreview } from 'src/popup'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import { useTranslation } from 'react-i18next'

const NonNigerianAccountOpeningDetails: React.FC<any> = () => {
    const navigate = useNavigate()
    const {info: {selectedAccountOpeningRequest}} = useContext(AppInfoContext)
    const [accountOpeningData,  setAccountOpeningData] = useState(selectedAccountOpeningRequest)
    const [docUrl, setDocUrl] = useState('')
    const [view, setView] = useState('')
    const { t } = useTranslation()

    useEffect(() => {
        if (selectedAccountOpeningRequest?.id) {
            setAccountOpeningData(selectedAccountOpeningRequest)
        }
    }, [selectedAccountOpeningRequest])

    function handleDocumentPreview (url: string) {
        setDocUrl(url)
        setView('doc-preview')
    }

    console.log("non-nigerian", selectedAccountOpeningRequest)
    
    return (
        <>
        <CustomContainer 
                      className='profile-container'
                  >
                      <CustomContainer>
                          <FlexRow 
                              justifyContent='flex-start' gap='1'
                              width='auto' sizeUnit=''
                              onClick={() => navigate(-1)}
                          >
                              <AppSpan textSize='2' cursor='pointer' >
                                  <IoIosArrowBack />
                              </AppSpan>
                              <AppText 
                                  textSize='3' fontWeight='600' color='#101828' cursor='pointer'
                              >
                                  {t('customer.nonNigerianAccount.requestDetails.detailsTitle')} ({selectedAccountOpeningRequest?.fullName || selectedAccountOpeningRequest?.accountNumber})
                              </AppText>
                          </FlexRow>
      
                          <FlexRow
                              bgColor='#ffffff' minHeight='10.6' 
                              alignItems='flex-start' justifyContent='flex-start'
                              radius='0.8' padding='2' topMargin="2"
                              gap='4' wrap='wrap' borderColor='#EAECF0'
                              shadow='0px 1px 2px 0px #1018280F' 
                          >
                              <CustomContainer width='20'>
                                  <AppText color='#333542' fontWeight='600' textSize="1.6">{t('customer.nonNigerianAccount.requestDetails.fullName')}</AppText>
                                  <AppSpan color='#333542' fontWeight='300'>{selectedAccountOpeningRequest?.fullName}</AppSpan>
                              </CustomContainer>
                              <CustomContainer width='20'>
                                  <AppText color='#333542' fontWeight='600' textSize="1.6">{t('customer.nonNigerianAccount.requestDetails.customerId')}</AppText>
                                  <AppSpan color='#333542' fontWeight='300'>{selectedAccountOpeningRequest?.customerID}</AppSpan>
                              </CustomContainer>
                              <CustomContainer width='20'>
                                  <AppText color='#333542' fontWeight='600' textSize="1.6">{t('customer.nonNigerianAccount.requestDetails.accountNumber')}</AppText>
                                  <AppSpan color='#333542' fontWeight='300'>{selectedAccountOpeningRequest?.accountNumber}</AppSpan>
                              </CustomContainer>

                              <CustomContainer width='20'>
                                  <AppText color='#333542' fontWeight='600' textSize="1.6">{t('customer.nonNigerianAccount.requestDetails.email')}</AppText>
                                  <AppSpan color='#333542' fontWeight='300'>{selectedAccountOpeningRequest?.email}</AppSpan>
                              </CustomContainer>

                              <CustomContainer width='20'>
                                  <AppText color='#333542' fontWeight='600' textSize="1.6">{t('customer.nonNigerianAccount.requestDetails.phoneNo')}</AppText>
                                  <AppSpan color='#333542' fontWeight='300'>{selectedAccountOpeningRequest?.phoneNo}</AppSpan>
                              </CustomContainer>

                              <CustomContainer width='20'>
                                  <AppText color='#333542' fontWeight='600' textSize="1.6">{t('customer.nonNigerianAccount.requestDetails.dob')}</AppText>
                                  <AppSpan color='#333542' fontWeight='300'>{selectedAccountOpeningRequest?.dateOfBirth ?  helpers.handleDate(selectedAccountOpeningRequest?.dateOfBirth) : null}</AppSpan>
                              </CustomContainer>
                              <CustomContainer width='20'>
                                  <AppText color='#333542' fontWeight='600' textSize="1.6">{t('customer.nonNigerianAccount.requestDetails.status')}</AppText>
                            <GridContainer
                                width='auto' sizeUnit="" minHeight='2.2'
                                bgColor={selectedAccountOpeningRequest.isAccountApproved === true ? '#ECFDF3' : selectedAccountOpeningRequest.isAccountApproved === false ? '#FFF5F5' : '#FEF0C7'}
                                topPadding='0' bottomPadding='0' padding='0.8' radius='1.6'
                            >
                                <AppSpan
                                    color={selectedAccountOpeningRequest.isAccountApproved === true ? '#027A48' : selectedAccountOpeningRequest.isAccountApproved === false ? '#DC2525' : '#B54708'}
                                    textSize='1.2' leftPadding='0.5' fontWeight='500'
                                >
                                    {selectedAccountOpeningRequest.isAccountApproved === true ? "Approved" : "Rejected"}
                                </AppSpan>
                            </GridContainer>
                              </CustomContainer>
                              {/* <CustomContainer width='20'>
                                  <AppText color='#333542' fontWeight='600' textSize="1.6">{t('customer.nonNigerianAccount.requestDetails.isUpgraded')}</AppText>
                                  <AppSpan color='#333542' fontWeight='300'>{selectedAccountOpeningRequest.isUpgraded ? 'TRUE' : 'FALSE'}</AppSpan>
                              </CustomContainer> */}
                              <CustomContainer width='20'>
                                  <AppText color='#333542' fontWeight='600' textSize="1.6">{t('customer.nonNigerianAccount.requestDetails.requestDate')}</AppText>
                                  <AppSpan color='#333542' fontWeight='300'>{selectedAccountOpeningRequest?.creationDate ? helpers.handleDate(selectedAccountOpeningRequest.creationDate) : selectedAccountOpeningRequest?.creationDate}</AppSpan>
                              </CustomContainer>
                              <CustomContainer width='20'>
                                  <AppText color='#333542' fontWeight='600' textSize="1.6">{t('customer.nonNigerianAccount.requestDetails.approvalDate')}</AppText>
                                  <AppSpan color='#333542' fontWeight='300'>{selectedAccountOpeningRequest?.approvalDate ? helpers.handleDate(selectedAccountOpeningRequest.approvalDate) : 'null'}</AppSpan>
                              </CustomContainer>

                               <CustomContainer width='20'>
                                  <AppText color='#333542' fontWeight='600' textSize="1.6">{t('customer.nonNigerianAccount.requestDetails.bankOne')}</AppText>
                                  <AppSpan color='#333542' fontWeight='300'>{selectedAccountOpeningRequest?.bankoneTrackingReference}</AppSpan>
                              </CustomContainer>
                          </FlexRow>
      
                          <CustomContainer topMargin="2" bottomPadding="1.5">
                              <FlexRow gap="1" justifyContent="flex-start">
                                  <IoIosInformationCircleOutline fill="#0D968F" fontSize='2.2rem' />
                                  <AppSpan textSize="2" fontWeight="600" color="#0D968F">{t('customer.nonNigerianAccount.requestDetails.approvalRequest')}</AppSpan>
                              </FlexRow>
      
                              <CustomContainer
                                  bgColor='#ffffff' minHeight='20.6' 
                                  radius='0.8' padding='2'
                                  borderColor='#EAECF0' topMargin="2"
                                  shadow='0px 1px 2px 0px #1018280F' 
                              >
                                  <FlexRow
                                      alignItems='flex-start' justifyContent='flex-start'
                                      gap='4' wrap='wrap'
                                  >
                              
                                      
                                      <CustomContainer width='20'>
                                          <AppText color='#333542' fontWeight='600' textSize="1.6">{t('customer.nonNigerianAccount.requestDetails.signature')}</AppText>
                                          { selectedAccountOpeningRequest?.customerSignatureUrl &&
                                              <CustomContainer 
                                                  width='14' height='7' 
                                                  radius="0.9" topMargin="0.6"
                                                  className="upgrade-doc-container"
                                              >
                                                  <img 
                                                      src={selectedAccountOpeningRequest.customerSignatureUrl} className='ads-img'
                                                      style={{objectFit: 'cover', objectPosition: 'left'}}  
                                                  />
                                                  <AbsoluteContainer 
                                                      height="full"
                                                      width="100" sizeUnit="%"
                                                      top="0" left="0"
                                                  >
                                                      <GridContainer 
                                                          height="100" hUnit="%" bgColor="rgba(0,0,0, 0.3)"
                                                          onClick={() => handleDocumentPreview(selectedAccountOpeningRequest.customerSignatureUrl)}
                                                      >
                                                          <AppText 
                                                              textSize="1.6" color="#ffffff" 
                                                              fontWeight="600" cursor='pointer'
                                                          >
                                                              {t('customer.nonNigerianAccount.requestDetails.common.view')}
                                                          </AppText>
                                                      </GridContainer>
                                                  </AbsoluteContainer>
                                              </CustomContainer>
                                          }
                                      </CustomContainer>
                                      <CustomContainer width='20'>
                                          <AppText color='#333542' fontWeight='600' textSize="1.6">{selectedAccountOpeningRequest?.identificationImageUrl || t('customer.nonNigerianAccount.requestDetails.idCard')}</AppText>
                                          { selectedAccountOpeningRequest?.identificationImageUrl &&
                                              <CustomContainer 
                                                  width='14' height='7' 
                                                  radius="0.9" topMargin="0.6"
                                                  className="upgrade-doc-container"
                                              >
                                                  <img 
                                                      src={selectedAccountOpeningRequest.identificationImageUrl} className='ads-img'
                                                      style={{objectFit: 'cover', objectPosition: 'left'}}  
                                                  />
                                                  <AbsoluteContainer 
                                                      height="full"
                                                      width="100" sizeUnit="%"
                                                      top="0" left="0"
                                                  >
                                                      <GridContainer 
                                                          height="100" hUnit="%" bgColor="rgba(0,0,0, 0.3)"
                                                          onClick={() => handleDocumentPreview(selectedAccountOpeningRequest.identificationImageUrl)}
                                                      >
                                                          <AppText 
                                                              textSize="1.6" color="#ffffff" 
                                                              fontWeight="600" cursor='pointer'
                                                          >
                                                              {t('customer.nonNigerianAccount.requestDetails.common.view')}
                                                          </AppText>
                                                      </GridContainer>
                                                  </AbsoluteContainer>
                                              </CustomContainer>
                                          }
                                      </CustomContainer>
                                      <CustomContainer width='20'>
                                          <AppText color='#333542' fontWeight='600' textSize="1.6">{t('customer.nonNigerianAccount.requestDetails.tinUrl')}</AppText>
                                          { selectedAccountOpeningRequest?.tinUrl &&
                                              <CustomContainer 
                                                  width='14' height='7' 
                                                  radius="0.9" topMargin="0.6"
                                                  className="upgrade-doc-container"
                                              >
                                                  <img 
                                                      src={selectedAccountOpeningRequest.tinUrl} className='ads-img'
                                                      style={{objectFit: 'cover', objectPosition: 'left'}}  
                                                  />
                                                  <AbsoluteContainer 
                                                      height="full"
                                                      width="100" sizeUnit="%"
                                                      top="0" left="0"
                                                  >
                                                      <GridContainer 
                                                          height="100" hUnit="%" bgColor="rgba(0,0,0, 0.3)"
                                                          onClick={() => handleDocumentPreview(selectedAccountOpeningRequest.tinUrl)}
                                                      >
                                                          <AppText 
                                                              textSize="1.6" color="#ffffff" 
                                                              fontWeight="600" cursor='pointer'
                                                          >
                                                              {t('customer.nonNigerianAccount.requestDetails.common.view')}
                                                          </AppText>
                                                      </GridContainer>
                                                  </AbsoluteContainer>
                                              </CustomContainer>
                                          }
                                      </CustomContainer>
                                      <CustomContainer width='20'>
                                          <AppText color='#333542' fontWeight='600' textSize="1.6">{t('customer.nonNigerianAccount.requestDetails.passport')}</AppText>
                                          { selectedAccountOpeningRequest?.identificationImageUrl &&
                                              <CustomContainer 
                                                  width='14' height='7' 
                                                  radius="0.9" topMargin="0.6"
                                                  className="upgrade-doc-container"
                                              >
                                                  <img 
                                                      src={selectedAccountOpeningRequest.identificationImageUrl} className='ads-img'
                                                      style={{objectFit: 'cover', objectPosition: 'left'}}  
                                                  />
                                                  <AbsoluteContainer 
                                                      height="full"
                                                      width="100" sizeUnit="%"
                                                      top="0" left="0"
                                                  >
                                                      <GridContainer 
                                                          height="100" hUnit="%" bgColor="rgba(0,0,0, 0.3)"
                                                          onClick={() => handleDocumentPreview(selectedAccountOpeningRequest.identificationImageUrl)}
                                                      >
                                                          <AppText 
                                                              textSize="1.6" color="#ffffff" 
                                                              fontWeight="600" cursor='pointer'
                                                          >
                                                              {t('customer.nonNigerianAccount.requestDetails.common.view')}
                                                          </AppText>
                                                      </GridContainer>
                                                  </AbsoluteContainer>
                                              </CustomContainer>
                                          }
                                      </CustomContainer>
                                  </FlexRow>
      
                                  { !selectedAccountOpeningRequest?.isUpgraded &&
                                      <FlexRow 
                                          justifyContent='flex-end'
                                          gap='1.5' topMargin='2.5' 
                                      >
                                          <Button
                                              width='8.9'
                                              fontWeight='600' height='4'
                                              hoverColor='#0D968F' borderColor='#0D968F'
                                              hoverBgColor='#fff'
                                              onClick={() => setView('approve')}
                                          >
                                              {t('customer.nonNigerianAccount.requestDetails.actions.approve')}
                                          </Button>
                                          <Button
                                              width='8.3' bgColor='#ffffff'
                                              fontWeight='600'
                                              height='4' color='#344054'
                                              borderColor='#D0D5DD'
                                              hoverBorderColor='#0D968F'
                                              onClick={() => setView('decline')}
                                          >
                                              {t('customer.nonNigerianAccount.requestDetails.actions.decline')}
                                          </Button>
                                      </FlexRow>
                                  }
                              </CustomContainer>
                          </CustomContainer>
                      </CustomContainer>
                  </CustomContainer>
                  {/* CUSTOM IMAGE PREVIEW LIGHTBOX */}
                  {/* { view === 'doc-preview' &&
                      <DocumentPreview 
                          docUrl={docUrl}
                          close={() => setView('')}
                      />
                  } */}
                  { view === 'doc-preview' &&
                      <Lightbox 
                          mainSrc={docUrl}
                          onCloseRequest={() => setView('')}
                          imageTitle={docUrl}
                      />
                  }
        </>
    )
}

export default utility.routeData('non-nigerian-account-opening-details', 'Non Nigerian Account Opening Request Details', <NonNigerianAccountOpeningDetails/>)